import { render, staticRenderFns } from "./ChroniclesDrawer.vue?vue&type=template&id=2ce2b49a&scoped=true"
import script from "./ChroniclesDrawer.vue?vue&type=script&lang=js"
export * from "./ChroniclesDrawer.vue?vue&type=script&lang=js"
import style0 from "./ChroniclesDrawer.vue?vue&type=style&index=0&id=2ce2b49a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce2b49a",
  null
  
)

export default component.exports